import CartItems from '@activities/cart/CartActivity/components/CartItems';
import BlankCart from '@components/blank/BlankCart';
import CtaLayout from '@components/CtaLayout';
import Header from '@components/Header';
import useCart from '@hooks/cart/useCart';
import { AppScreen } from '@stackflow/plugin-basic-ui';
import { ActivityComponentType } from '@stackflow/react';
import usePrepareWithCart from '@store/cart/hooks/usePrepareWithCart';

import CartFooter from './components/CartFooter';
import CartNote from './components/CartNote';
import ShopLocation from './components/ShopLocation';

interface Params {
    shopId: string
}

const CartActivity: ActivityComponentType<Params> = ({ params }:{params: Params}) => {
  const { shopId } = params;
  const cart = useCart(shopId);
  usePrepareWithCart(shopId);
  if (cart) {
    return (
        <AppScreen>
            <CtaLayout header={<Header title='장바구니' />}
                       footer={<CartFooter/>} >
                <ShopLocation/>
                {cart && (
                    <CartItems shopId={shopId}
                               cartId={cart.cartId} />
                )}
                <CartNote/>
            </CtaLayout>
        </AppScreen>
    );
  }
  return (
        <AppScreen>
            <Header title='장바구니' />
            <BlankCart/>
        </AppScreen>
  );
};

export default CartActivity;
